import { api } from './api.config'
import request from '@/utils/request'
export default {
  reim: {
    getReimList (data) {
      return request({
        url: api.reim.getReimList,
        method: 'post',
        data
      })
    },
    getExamineInfo (data) {
      return request({
        url: api.reim.getExamineInfo,
        method: 'post',
        data
      })
    },
    getExaminePage (data) {
      return request({
        url: api.reim.getExaminePage,
        method: 'post',
        data
      })
    },
    examine (data) {
      return request({
        url: api.reim.examine,
        method: 'post',
        data
      })
    },
    getReimInfo (data) {
      return request({
        url: api.reim.getReimInfo,
        method: 'get',
        data
      })
    },
    addOrEditReim (data) {
      return request({
        url: api.reim.addOrEditReim,
        method: 'post',
        data
      })
    },
    delReimById (data) {
      return request({
        url: api.reim.delReimById,
        method: 'get',
        data
      })
    }
  }
}
